/* global femcare */

femcare.ctaPanel.quickBuy = {
    $quickBuyButton: $('.cta-panel .cta-panel__quick-buy-button'),
    productsData: window.pr_render_quick_buy_data,
    $quickBuyModal: $('.modal--quick-buy'),
    pdpOptionState: [],

    init: function () {
        this.isSearchPage();

        if (this.$quickBuyButton.length && this.productsData?.length) {
            this.openModal();
        }
    },

    generateModal: function (id) {
        var $modal = this.$quickBuyModal;

        this.savePdpOptionState();

        this.productsData.forEach(function (element) {
            var productId = element.ProductId;

            if (productId === id) {
                var productContent = element.detailQuickBuyHtml;
                var parser = new DOMParser();
                var parsedContent = parser.parseFromString(productContent, 'text/html');
                var contentToUse = parsedContent.body.firstElementChild;
                $modal.find('.modal__body').html(contentToUse);
            }
        })

        var $product = $modal.find('.product-main--shop-slim');
        this.namespaceModalInputs($product, id);
        this.protectPdpOptions($product);

        var quickBuyReviewSnippetId = 'pr-reviewsnippet-quick-buy';

        $product.find('#pr-reviewsnippet')
            .attr('id', quickBuyReviewSnippetId)
            .empty();

        var productId = $product[0].dataset.productid;
        var productReviewComponent = JSON.parse($product[0].dataset.productReviewComponents);

        if (productReviewComponent.ReviewSnippet === 'pr-reviewsnippet') {
            productReviewComponent.ReviewSnippet = quickBuyReviewSnippetId;
        }

        this.renderPowerReviews(productId, productReviewComponent);
        setTimeout(() => {
            femcare.product.panel.info.shop.mainPanelSlim($product);
        }, 10);
    },

    getPdpOptionInputs: function () {
        return $('.product-main--shop')
            .not('.product-main--shop-slim')
            .find('.product-main-options input');
    },

    savePdpOptionState: function () {
        this.pdpOptionState = this.getPdpOptionInputs().map(function () {
            var $input = $(this);

            return {
                input: this,
                checked: $input.prop('checked'),
                disabled: $input.prop('disabled')
            };
        }).get();
    },

    restorePdpOptionState: function () {
        this.pdpOptionState.forEach(function (optionState) {
            $(optionState.input)
                .prop('checked', optionState.checked)
                .prop('disabled', optionState.disabled);
        });
    },

    protectPdpOptions: function ($product) {
        $product.find('.product-main-options input')
            .off('click.quickBuyProtect change.quickBuyProtect')
            .on('click.quickBuyProtect change.quickBuyProtect', () => {
                setTimeout(() => {
                    this.restorePdpOptionState();
                }, 0);
            });
    },

    namespaceModalInputs: function ($product, id) {
        var namespace = 'quick-buy-' + id + '-';

        $product.find('.product-main-options .form-group--product-radio-group').each(function () {
            var $group = $(this);
            var groupId = $group.attr('id');

            if (groupId) {
                if (!$group.attr('data-option-name')) {
                    $group.attr('data-option-name', groupId);
                }

                $group.attr('id', namespace + groupId);
            }
        });

        $product.find('.product-main-options input').each(function () {
            var $input = $(this);
            var inputId = $input.attr('id');
            var inputName = $input.attr('name');

            if (inputId) {
                var namespacedId = namespace + inputId;

                $product.find('label').filter(function () {
                    return $(this).attr('for') === inputId;
                }).attr('for', namespacedId);
                $input.attr('id', namespacedId);
            }

            if (inputName) {
                $input.attr('name', namespace + inputName);
            }
        });
    },

    openModal: function () {
        const quickBuySelector = '.cta-panel .cta-panel__quick-buy-button';

        // Delegation keeps Quick Buy working when product cards are sorted or replaced by search.
        $(document)
            .off('click.quickBuy', quickBuySelector)
            .on('click.quickBuy', quickBuySelector, (e) => {
                e.preventDefault();

                // Each time modal for quick buy is opened we want to reset previously selected options for product
                femcare.product.panel.info.shop.resetSelectedOptions();

                var productId = e.currentTarget.dataset.productid;
                this.generateModal(productId);
            });
    },

    renderPowerReviews: function (productId, productReviewComponent) {
        var isPowerReviewsLoaded = window.POWERREVIEWS;
        if (isPowerReviewsLoaded) {
            var pr_render_options = window.pr_render_options || []
            pr_render_options.forEach(function (element, index) {
                var reviewSnippetId = pr_render_options[index].page_id;

                if (reviewSnippetId === productId) {
                    var renderData = $.extend(true, {}, pr_render_options[index]);
                    renderData.components = productReviewComponent;
                    window.POWERREVIEWS.display.render(renderData);
                }
            })
        }
    },

    isSearchPage: function () {
        var searchPageIndicator = $('.search-results');

        if (searchPageIndicator.length) {
            this.$quickBuyButton = $('.cta-panel .cta-panel__quick-buy-button');
        }
    }
}
